import API, { baseURL } from './api';
import { getSucursalInfo, getUserInfo } from './auth';

// Client for sge_infantil_core's routes/uniform.js (mounted at /api/uniform).
// Uses the single-item POST /:id/sale for Vendas — the bulk POST /sale has a
// known latent bug (references a block-scoped loop variable after the loop
// ends when sucursalId is falsy), so selling one article at a time avoids it.
export async function listUniforms(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/uniform/${id}`);
}

export async function createUniform(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/uniform`, { sucursalId, createdBy: getUserInfo()?.id, ...payload });
}

export async function updateUniform(id, payload) {
  return API.put(`${baseURL}api/uniform/${id}`, payload);
}

export async function addStock(id, quantidade) {
  return API.post(`${baseURL}api/uniform/${id}/addstock`, { quantidade });
}

export async function sellUniform(id, { quantidade, estado }) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/uniform/${id}/sale`, {
    quantidade,
    vendidoPor: getUserInfo()?.id,
    sucursalId,
    estado,
  });
}

export async function listSales(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/uniform/sales/sucursal/${id}`);
}
